import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const ITEMS = [
  { name: "Syllabus", to: "/syllabus", icon: <SchoolIcon fontSize="small" /> },
  // { name: "Prospectus", to: "/download/prospectus.pdf", icon: <DescriptionIcon fontSize="small" /> },
  { name: "Fee Structure", to: "/feestructure", icon: <ReceiptLongIcon fontSize="small" /> },
];

export default function AcademicSection({ syllabusRef }) {
  const onClickItem = (e, name, to) => {
    // Smooth-scroll only for the Syllabus anchor; others behave like links
    if (name === "Syllabus" && syllabusRef?.current) {
      e.preventDefault();
      syllabusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        background: "linear-gradient(135deg, rgba(14,165,233,0.10) 0%, rgba(99,102,241,0.06) 100%)",
        border: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CardContent sx={{ p: 2 }}>
        {/* Header */}
        <Chip
          size="small"
          label="Academic"
          sx={{
            fontWeight: 700,
            letterSpacing: 0.2,
            bgcolor: "info.main",
            color: "info.contrastText",
            "& .MuiChip-label": { px: 1 },
            mb: 1,
          }}
        />
        <Divider sx={{ mb: 1 }} />

        {/* List */}
        <List disablePadding sx={{ display: "grid", gap: 0.5 }}>
          {ITEMS.map(({ name, to, icon }) => (
            <ListItem
              key={name}
              disableGutters
              sx={{
                borderRadius: 1.5,
                px: 1,
                py: 0.75,
                minHeight: 48, // touch target
                transition: "background-color .2s ease",
                "&:hover": { bgcolor: "action.hover" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 30, color: "text.secondary" }}>
                {icon}
              </ListItemIcon>

              {name === "Syllabus" ? (
                <Link
                  href={to}
                  underline="none"
                  onClick={(e) => onClickItem(e, name, to)}
                  sx={{
                    fontSize: { xs: 13, sm: 13.5 },
                    fontWeight: 600,
                    color: "text.primary",
                    "&:hover": { color: "primary.main" },
                  }}
                >
                  {name}
                </Link>
              ) : (
                <Link
                  component={RouterLink}
                  to={to}
                  underline="none"
                  sx={{
                    fontSize: { xs: 13, sm: 13.5 },
                    fontWeight: 600,
                    color: "text.primary",
                    "&:hover": { color: "primary.main" },
                  }}
                  target={to.endsWith(".pdf") ? "_blank" : undefined}
                  rel={to.endsWith(".pdf") ? "noreferrer" : undefined}
                >
                  {name}
                </Link>
              )}
            </ListItem>
          ))}
        </List>

        {/* Optional small helper text */}
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
            Tip: Tap <strong>Syllabus</strong> to jump to the downloads section.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}


// import React from "react";
// import { Box, Typography } from "@mui/material";
// import { Link } from "react-router-dom";

// export default function Syllabus({ syllabusRef }) {
//   const Fee = [
//     {
//       name: "Syllabus",
//       link: "#",
//     },
//     {
//       name: "Prospectus",
//       link: "#",
//     },
//     {
//       name: "Fee Structure",
//       link: "#",
//     },
//   ];

//   const scrollToSection = (event, name) => {
//     event.preventDefault();
//     if (name === "Syllabus" && syllabusRef?.current) {
//       syllabusRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <div className="w-full max-w-sm rounded-lg border bg-white shadow-sm p-4">
//       <h3 className="text-sm font-semibold mb-2 text-gray-800">Academic</h3>
//       <ul className="space-y-2">
//         {Fee.map((item, idx) => (
//           <li key={idx}>
//             <a
//               href={item.link}
//               onClick={(e) => scrollToSection(e, item.name)}
//               className="text-xs text-blue-600 hover:underline"
//             >
//               {item.name}
//             </a>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

    // <div
    // key="syllabus_key"
    //   classNameName="col-lg-4 mb-3 mb-sm-0"
    //   style={{
    //     boxSizing: "border-box",
    //     position: "relative",
    //     width: "100%",
    //     paddingRight: "15px",
    //     paddingLeft: "15px",
    //     flex: "0 0 33.3333%",
    //     maxWidth: "85%",
    //     marginBottom: "0px",
    //   }}
    // >
    //   <Box
    //     sx={{
    //       backgroundColor: "rgb(244, 245, 247)",
    //       padding: "30px",
    //       borderTop: "5px solid rgb(255, 255, 255)",
    //       height: "auto",
    //       borderColor: "rgb(47, 153, 104)",
    //     }}
    //   >
    //     <Typography
    //       variant="h4"
    //       gutterBottom
    //       sx={{
    //         lineHeight: 1.2,
    //         fontWeight: 400,
    //         fontSize: "1.75em",
    //         marginBottom: "0.5rem",
    //         fontFamily: "Didot, serif",
    //       }}
    //     >
    //       Academic
    //     </Typography>
    //     <div
    //       className="guidlines notiScrollbar mCustomScrollbar _mCS_1"
    //       style={{
    //         boxSizing: "border-box",
    //         touchAction: "pinch-zoom",
    //         height: "210px",
    //       }}
    //     >
    //       <div
    //         id="mCSB_1"
    //         className="mCustomScrollBox mCS-dark-2 mCSB_vertical mCSB_inside"
    //         tabIndex="0"
    //         style={{
    //           boxSizing: "border-box",
    //           overflow: "hidden",
    //           outline: "none",
    //           position: "relative",
    //           height: "100%",
    //           maxWidth: "100%",
    //           direction: "ltr",
    //           maxHeight: "none",
    //           fontFamily: "Didot, serif",
    //           fontSize: 20,
    //         }}
    //       >
    //         <div
    //           id="mCSB_1_container"
    //           className="mCSB_container"
    //           dir="ltr"
    //           style={{
    //             boxSizing: "border-box",
    //             overflow: "hidden",
    //             width: "auto",
    //             height: "auto",
    //             marginRight: "30px",
    //             position: "relative",
    //             top: "0px",
    //             left: "0px",
    //           }}
    //         >
    //           <ul
    //             style={{
    //               boxSizing: "border-box",
    //               margin: "0px",
    //               padding: "0px",
    //               marginTop: "0px",
    //               marginBottom: "0px",
    //               paddingLeft: "15px",
    //               minHeight: "215px",
    //             }}
    //           >
    //             {Fee.map((e, index) => {
    //               return (
    //                 <li
    //                   key={index}
    //                   style={{
    //                     boxSizing: "border-box",
    //                     margin: "0px",
    //                     listStyle: 'url("assets/images/notice/bullet.png")',
    //                     padding: "0px",
    //                     // borderBottom: "1px dashed rgb(153, 153, 153)",
    //                   }}
    //                 >
    //                   <Box
    //                     // onScroll={
    //                     //   e.name === "Syllabus"
    //                     //     ? scrollToSection("syllabus")
    //                     //     : null
    //                     // }
    //                     // to={scrollToSection(e.name)}
    //                     // target="_parent"
    //                     onClick={(event) => scrollToSection(event, e.name)}
    //                     style={{
    //                       boxSizing: "border-box",
    //                       backgroundColor: "transparent",
    //                       textDecoration: "none",
    //                       padding: "10px 0px",
    //                       color: "rgb(51, 51, 51)",
    //                       fontWeight: 400,
    //                       display: "block",
    //                       fontFamily: "Didot, serif",
    //                       fontSize: 20,
    //                     }}
    //                   >
    //                     <Typography
    //                       style={{
    //                         fontWeight: 300,
    //                         display: "block",
    //                         fontFamily: "Didot, serif",
    //                         fontSize: 20,
    //                       }}
    //                       sx={{
    //                         pl: "15px",
    //                         transition: "transform 0.3s, box-shadow 0.3s",
    //                         "&:hover": {
    //                           transform: "scale(1.05)",
    //                           boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    //                         },
    //                         // "&:hover": {
    //                         //   textDecoration: "underline blue",
    //                         //   color: "black",
    //                         // },
    //                       }}
    //                       variant="h5"
    //                     >
    //                       {e.name}
    //                     </Typography>
    //                   </Box>
    //                 </li>
    //               );
    //             })}
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   </Box>
    // </div>
//   );
// }
